export default (object: { [key: string]: any } | undefined) => {
  if (object) {
    return !Object.keys(object).length;
  }
  return true;
};
